import { ProductList } from "pages/Inventori/Transaction/AddNewItem/types";
import { useEffect, useState } from "react";
import { PaginationState, SuccessFetch } from "types";
import { useApi } from "utils";

export interface FilteredParams extends PaginationState {
    group_id?: string
}

interface DataType extends ProductList{
    cac: number,
    cogm: number,
    cogm_percent: number,
    profit_percent: number,
    profit_wholesales_percent: number,
    price_retail: number,
    wholesales: number,
    distributor_price: number,
    profit_distributor_percent: number,
    factory_price: number,
    profit_factory_percent: number,
    online_price: number,
    profit_online_percent: number
}

interface DataPagingType {
    items: DataType[]
    pagination_data: {
        total: number
        page: number
        size: number
        pages: number
    }
}

export function useList({ page, keyword, limit, group_id }: FilteredParams) {
    const defaultValue = {
        items: [],
        pagination_data: {
            page: 0,
            pages: 0,
            size: 0,
            total: 0
        }
    }

    const api = useApi()
    const [data, setData] = useState<DataPagingType>(defaultValue)
    const [isLoading, setLoading] = useState(true)

    const params: { [key: string]: number | string | undefined } = {};
    if (page) params.page = page;
    if (keyword) params.keyword = keyword;
    if (limit) params.limit = limit;
    if (group_id) params.group_id = group_id;

    useEffect(() => {
        setLoading(true)

        api.get("/pricing_analyze/data_price_analyze", { params })
            .then((res: SuccessFetch<{ payload: DataPagingType }>) => setData(res.data.payload))
            .catch(() => setData(defaultValue))
            .finally(() => setLoading(false))

        // eslint-disable-next-line
    }, [page, keyword, limit, group_id])

    return { data, isLoading }
}